import { OptionItem } from '../models/other/option-item.model';
import { FitBoundsOptions } from 'leaflet';
import { VehicleStatusEnum } from '../models/domain/VehicleStatusEnum';
import { GroupMarkerColorsEnum } from '../enums/group-marker-colors.enum';
import { TachoStatusWorker } from '@commons/enums/tacho.enum';

export class Consts {

    // zdarzenia
    public static readonly EventFuelAll = 0;
    public static readonly EventFuelRefuelling = 1;
    public static readonly EventFuelLoss = 2;
    public static readonly EventAreaAll = 0;
    public static readonly EventAreaEnter = 1;
    public static readonly EventAreaExit = 2;

    public static readonly InitDataFlow = 'InitDataFlow';
    public static readonly VehicleDataLoaded = 'VehicleDataLoaded';
    public static readonly Vehicle = 'Vehicle';
    public static readonly DriverDataLoaded = 'DriverDataLoaded';
    public static readonly DriverChanges = 'DriverChanges';
    public static readonly VehicleChanges = 'VehicleChanges';
    public static readonly Driver = 'Driver';
    public static readonly VehiclesIndicatorDataLoaded = 'VehiclesIndicatorDataLoaded';
    public static readonly VehicleControlIndicator = 'VehicleControlIndicator';
    public static readonly VehicleOnTheMapClicked = 'VehicleOnTheMapClicked';

    public static readonly driverDisplayFields: OptionItem[] = [
        { label: 'Eco/Safe', value: 0 },
        // { label: 'Tacho', value: 1 },
    ];

    public static readonly driverStatuses: OptionItem[] = [
        { label: 'driver-status.all', value: 0 },
        { label: 'driver-status.status-unknown', value: 1 },
        { label: 'driver-status.driving', value: 2 },
        { label: 'driver-status.parking', value: 3 },
        { label: 'driver-status.no-vehicle', value: 4 },
    ];

    public static readonly vehicleStatuses: OptionItem[] = [
        // { label: 'labels.all', value: 0 },
        { label: 'vehicle-status.driving', value: 2, checkboxColor: '#40c734' },
        { label: 'vehicle-status.parked', value: 4, checkboxColor: '#2d78ff' },
        { label: 'vehicle-status.device-issue', value: 1, checkboxColor: '#ff0032'},
        // { label: 'vehicle-status.towing', value: 6, checkboxColor: '#ff0032'}
    ];

    public static readonly vehicleTachoStatuses: OptionItem[] = [
        { label: 'drive', value: TachoStatusWorker.Driving, checkboxColor: '#54c732' },
        { label: 'work', value: TachoStatusWorker.Work, checkboxColor: '#FF0032' },
        { label: 'vehicle-details-tacho-tab.rest', value: TachoStatusWorker.Rest, checkboxColor: '#2D78FF'},
        { label: 'available', value: TachoStatusWorker.Free, checkboxColor: '#c89c0f'},
        { label: 'unknown', value: TachoStatusWorker.Unkown, checkboxColor: '#969696'},
    ];

    public static readonly vehicleIndicatorTypes: OptionItem[] = [
        { label: Consts.getVehicleIndicatorDisplayName(12), value: 12 },
        { label: Consts.getVehicleIndicatorDisplayName(6), value: 6 },
        { label: Consts.getVehicleIndicatorDisplayName(7), value: 7 },
        { label: Consts.getVehicleIndicatorDisplayName(5), value: 5 },
        // { label: Consts.getVehicleIndicatorDisplayName(8), value: 8 },
        { label: Consts.getVehicleIndicatorDisplayName(19), value: 19 }
    ];

    public static readonly fieldTypes: OptionItem[] = [
        { label: 'search-type.in-name', value: 'Description' },
        { label: 'search-type.in-address', value: 'Location' }
    ];


    public static readonly alarmEventActionType: OptionItem[] = [
        { label: 'labels.all', value: 0 }
    ];

    public static readonly fuelEventActionType: OptionItem[] = [
        { label: 'labels.all', value: 0 },
        { label: 'fuel-status.refueling', value: 1 },
        { label: 'fuel-status.drain', value: 2 }
    ];

    public static readonly areaEventActionType: OptionItem[] = [
        { label: 'labels.all', value: 0 },
        { label: 'area-event-type.entry', value: 1 },
        { label: 'area-event-type.leaves', value: 2 }
    ];

    public static getVehicleIndicatorName(vehicleIndicatorType: number): string {
        switch (vehicleIndicatorType) {
            case 5:
                return 'rpm';
            case 100:
                return 'gps';
            case 22:
                return 'gsm';
            case 1:
                return 'fuel';
            // case 27:
            //     return 'fuel-cam';
            case 7:
                return 'power';
            case 2:
                return 'speed';
            case 16:
                return 'ignition';
            // case 8:
            //     return 'aerial-platform';
            // case 9:
            //     return 'cap';
          default:
            throw new Error('Unsupported vehicleIndicatorType: ' + vehicleIndicatorType);
        }
    }

    public static getVehicleIndicatorDisplayName(group: number): string {
        switch (group) {
            // prędkość
            case 12:
                return 'vehicle-indicator.speed';
            // napiecie
            case 6:
                return 'vehicle-indicator.voltage';
            // obroty
            case 7:
                return 'vehicle-indicator.rpm';
            // licznik
            case 5:
                return 'vehicle-indicator.counter';
            // paliwo
            case 8:
                return 'vehicle-indicator.fuel';
            case 19:
                return 'vehicle-indicator.eToll';
            default:
                return 'vehicle-indicator.group' + ' ' + group;
        }
    }

    public static readonly MapPadding : FitBoundsOptions = { padding: [60, 60] };

    public static readonly binaryIndicators: number[] = [
        9, // binarny
        19, // ruch (binarny)
        26 // wypadku
    ];


    public static readonly VehicleSettingsByStatusMap = new Map([
        [
            VehicleStatusEnum.Moving, {
                groupMarkerColor: GroupMarkerColorsEnum.Green,
                markerNumber: 2,
                statusPopupMapIconUrl: '/assets/img/status/primary@3x.png',
                statusIconUrl: 'status/primary.png',
                statusClass: 'moving'
            }
        ],
        [
            VehicleStatusEnum.Parked, {
                groupMarkerColor: GroupMarkerColorsEnum.Blue,
                markerNumber: 4,
                statusPopupMapIconUrl: '/assets/img/status/parking@3x.png',
                statusIconUrl: 'status/parking.png',
                statusClass: 'parked'
            }
        ],
        [
            VehicleStatusEnum.NoGPS, {
                groupMarkerColor: GroupMarkerColorsEnum.Red,
                markerNumber: 1,
                statusPopupMapIconUrl: '/assets/img/status/error@3x.png',
                statusIconUrl: 'status/error.png',
                statusClass: 'fail'
            }
        ],
        [
            VehicleStatusEnum.NoGSM, {
                groupMarkerColor: GroupMarkerColorsEnum.Red,
                markerNumber: 1,
                statusPopupMapIconUrl: '/assets/img/status/error@3x.png',
                statusIconUrl: 'status/error.png',
                statusClass: 'fail'
            }
        ],
        [
            VehicleStatusEnum.Disconnected, {
                groupMarkerColor: GroupMarkerColorsEnum.Red,
                markerNumber: 1,
                statusPopupMapIconUrl: '/assets/img/status/error@3x.png',
                statusIconUrl: 'status/error.png',
                statusClass: 'fail'
            }
        ],
        [
            VehicleStatusEnum.Towed, {
                groupMarkerColor: GroupMarkerColorsEnum.Red,
                markerNumber: 3,
                statusPopupMapIconUrl: '/assets/img/status/towed@3x.png',
                statusIconUrl: 'status/towed.png',
                statusClass: 'fail'
            }
        ]
    ]);

    public static ETollStatusToIconMapping = new Map([
        [0, {
            iconUrl: '/assets/img/e-toll/status-unregistered.png'
        }],
        [1, {
            iconUrl: '/assets/img/e-toll/status-disabled.png'
        }],
        [2, {
            iconUrl: '/assets/img/e-toll/status-enabled.png'
        }],
        [3, {
            iconUrl: '/assets/img/e-toll/status-error.png'
        }]
    ]);
}
